import type { NavigationItem } from "@/components/ui/navigation/types";

/** Stable ascending sort by `order` (undefined treated as 0). */
export function sortByOrder(items: NavigationItem[]): NavigationItem[] {
  return [...items].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export interface SplitChildren {
  /** Children shown up-front in the dropdown, in display order. */
  visible: NavigationItem[];
  /** Children collapsed under the "More" expander, in display order. */
  hidden: NavigationItem[];
}

/**
 * Splits a parent's children into the up-front list and the "More" list,
 * each sorted by `order`. A child is hidden only when `visible === false`,
 * so items that never opted into customization stay visible by default.
 */
export function splitChildrenByVisibility(
  children: NavigationItem[] | undefined
): SplitChildren {
  if (!children || children.length === 0) {
    return { visible: [], hidden: [] };
  }
  const sorted = sortByOrder(children);
  return {
    visible: sorted.filter((c) => c.visible !== false),
    hidden: sorted.filter((c) => c.visible === false),
  };
}
